
import React from 'react';
import { Search, MessageSquare, BarChart3, Lightbulb, Sparkles, Globe } from 'lucide-react';
import { TopicType } from '@/types/assistant';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';

interface CategoryIconProps {
  category: TopicType;
  className?: string;
  size?: number;
  showAnimation?: boolean;
  isMultiLanguage?: boolean; // New prop to indicate multi-language content
}

export const CategoryIcon: React.FC<CategoryIconProps> = ({ 
  category, 
  className, 
  size = 16,
  showAnimation = false,
  isMultiLanguage = false
}) => {
  const icon = () => {
    switch(category) {
      case 'guide':
        return <Search className={cn("", className)} size={size} />;
      case 'performance':
        return <BarChart3 className={cn("", className)} size={size} />;
      case 'trading_strategy':
        return <MessageSquare className={cn("", className)} size={size} />;
      case 'advisor':
        return <Lightbulb className={cn("", className)} size={size} />;
      default:
        return <MessageSquare className={cn("", className)} size={size} />;
    }
  };

  // If multi-language is active, we'll show a globe icon or add some indicator
  const renderIcon = () => {
    if (isMultiLanguage) {
      return (
        <div className="relative">
          {icon()}
          <Globe className={cn("absolute -bottom-1 -right-1 text-blue-500", className)} size={size * 0.6} />
        </div>
      );
    }
    return icon();
  };

  if (showAnimation) {
    return (
      <motion.div
        whileHover={{ rotate: [0, -10, 10, 0], scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        animate={showAnimation ? {
          scale: [1, 1.1, 1],
          rotate: [0, 5, -5, 0],
          transition: { duration: 2, repeat: Infinity, repeatType: "reverse" }
        } : {}}
      >
        {renderIcon()}
      </motion.div>
    );
  }

  return renderIcon();
};
